(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clothe-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('clothe-carousel')) {
  customElements.define('clothe-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('.clothe-carousel__track');
      this.slides = [...this.track.children];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.go(this.index + Number(button.dataset.direction)), options));
      this.dots.forEach(button => button.addEventListener('click', () => this.go(this.visibleSlides().indexOf(this.slides[Number(button.dataset.slide)])), options));
      this.track.addEventListener('scroll', () => this.update(), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.visibleSlides().findIndex(slide => slide.contains(event.target));
        if (index >= 0) this.go(index);
      }, options);
      this.observer = new ResizeObserver(() => { const slides=this.visibleSlides(); this.index=Math.min(this.index,slides.length-1); this.track.scrollTo({left:this.index*this.track.clientWidth, behavior:'instant'}); this.update(); });
      this.observer.observe(this.track);
      this.update();
    }
    visibleSlides() { return this.slides.filter(slide => getComputedStyle(slide).display !== 'none'); }
    go(index) {
      const slides = this.visibleSlides();
      const next = (index + slides.length) % slides.length;
      this.track.scrollTo({left:next*this.track.clientWidth, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
    }
    update() {
      this.index = Math.round(this.track.scrollLeft / this.track.clientWidth) || 0;
      const active = this.visibleSlides()[this.index];
      this.dots.forEach(dot => { if(this.slides[Number(dot.dataset.slide)]===active) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
      this.slides.forEach(slide => { slide.inert = slide !== active; });
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.initialized=false; }
  });
}
if(!customElements.get('clothe-collection-showcase')) customElements.define('clothe-collection-showcase',class extends HTMLElement {
connectedCallback() {
this.track=this.querySelector('ul'); this.buttons=[...this.querySelectorAll('button')]; this.controller=new AbortController(); const options={signal:this.controller.signal};
this.buttons.forEach(button=>button.addEventListener('click',()=>{ const item=this.track.firstElementChild; const step=item.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap); this.track.scrollBy({left:Number(button.dataset.direction)*step,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'}); },options));
this.track.addEventListener('scroll',()=>this.update(),options); this.observer=new ResizeObserver(()=>this.update()); this.observer.observe(this.track); this.update();
}
update(){ this.buttons.forEach(button=>button.disabled=Number(button.dataset.direction)<0?this.track.scrollLeft<=1:this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-1); }
disconnectedCallback(){this.controller.abort();this.observer.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothe-font-review"]) return;
  try {
    
if (!customElements.get('clothe-font-review')) {
  customElements.define('clothe-font-review', class extends HTMLElement {
    connectedCallback() {
      this.labels = {
        current: 'Current fonts · original homepage typography',
        a: 'A · Cormorant headings + Jost supporting text',
        b: 'B · Playfair Display headings + Jost supporting text',
        c: 'C · Lora headings + Jost supporting text',
        d: 'D · Jost headings + Jost supporting text'
      };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-font]');
        if (!button || !this.contains(button)) return;
        document.documentElement.dataset.clotheFontReview = button.dataset.font;
        this.querySelectorAll('button').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
        this.querySelector('.clothe-font-review__status').textContent = this.labels[button.dataset.font];
      });
    }
    disconnectedCallback() {
      delete document.documentElement.dataset.clotheFontReview;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clothe-product-rail"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('clothe-product-rail')) customElements.define('clothe-product-rail', class extends HTMLElement {
  connectedCallback() {
    if(this.ready) return;
    this.ready=true;
    this.track=this.querySelector('ul');
    this.items=[...this.track.children];
    this.controller=new AbortController();
    const options={signal:this.controller.signal};
    this.buttons=[...this.querySelectorAll('[data-direction]')];
    this.buttons.forEach(button=>button.addEventListener('click',()=>this.move(Number(button.dataset.direction)),options));
    this.track.addEventListener('scroll',()=>this.update(),options);
    this.track.addEventListener('keydown',event=>{if(event.target===this.track && ['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();this.move(event.key==='ArrowRight'?1:-1);}},options);
    this.track.addEventListener('focusin',event=>{const item=event.target.closest('li');if(item)item.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});},options);
    this.observer=new ResizeObserver(()=>{ const width=this.track.clientWidth; if(width!==this.lastWidth){ this.lastWidth=width; this.track.scrollLeft=0; } this.update(); });
    this.observer.observe(this.track);
    this.track.scrollLeft=0;
    this.update();
  }
  move(direction) {
    if(!this.items.length) return;
    const step=this.items[0].getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap);
    this.track.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  }
  update() {
    const frame=this.track.getBoundingClientRect();
    this.items.forEach(item=>{const rect=item.getBoundingClientRect();const visible=Math.max(0,Math.min(rect.right,frame.right)-Math.max(rect.left,frame.left));const center=(rect.left+rect.right)/2;const edge=innerWidth>=750 && (center<frame.left+rect.width || center>frame.right-rect.width);item.classList.toggle('is-edge',visible<rect.width*.95 || edge);});
    this.buttons.forEach(button=>button.disabled=Number(button.dataset.direction)<0?this.track.scrollLeft<=1:this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-1);
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
